import { __assign } from "tslib";
import { CounterBadge, mergeClasses } from '@fluentui/react-components';
import React, { useMemo } from 'react';
import { useBadgeStyles } from './Badge.styles';
import { useFlyoutButtonBadgeStyles } from './FlyoutButtonBadge.styles';
import useAppBarContext from './hooks/useAppBarContext';
export var FlyoutButtonBadge = function (_a) {
    var enabledFlyoutButtonBadgeType = _a.enabledFlyoutButtonBadgeType, flyoutButtonBadgeDescription = _a.flyoutButtonBadgeDescription;
    var appBarContext = useAppBarContext();
    var overflowItems = appBarContext.overflowItems;
    var hasDotBadge = useMemo(function () {
        return overflowItems === null || overflowItems === void 0 ? void 0 : overflowItems.some(function (tile) {
            var _a;
            return (((_a = tile.data.node.badge) === null || _a === void 0 ? void 0 : _a.__typename) === 'M365ApplicationDotBadge');
        });
    }, [overflowItems]);
    var numericBadgeCount = useMemo(function () {
        var _a;
        return ((_a = overflowItems === null || overflowItems === void 0 ? void 0 : overflowItems.reduce(function (acc, tile) {
            var _a, _b, _c;
            if (((_a = tile.data.node.badge) === null || _a === void 0 ? void 0 : _a.__typename) ===
                'M365ApplicationNumericBadge') {
                return acc + ((_c = (_b = tile.data.node.badge) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : 0);
            }
            return acc;
        }, 0)) !== null && _a !== void 0 ? _a : 0);
    }, [overflowItems]);
    var flyoutButtonBadgeStyles = useFlyoutButtonBadgeStyles();
    var commonBadgeStyles = useBadgeStyles();
    var badgeStyles = __assign(__assign({}, flyoutButtonBadgeStyles), commonBadgeStyles);
    var badgeElement = useMemo(function () {
        var badgeElement = null;
        if ((enabledFlyoutButtonBadgeType === 'Numeric' ||
            enabledFlyoutButtonBadgeType === 'All') &&
            numericBadgeCount > 0) {
            var numericBadgeClassNames = mergeClasses(badgeStyles.badgeWide, badgeStyles.defaultBadge, badgeStyles.flyoutButtonBadgeWide);
            badgeElement = (React.createElement(React.Fragment, null,
                React.createElement(CounterBadge, { size: "small", shape: "circular", color: "danger", appearance: "filled", count: numericBadgeCount, className: numericBadgeClassNames }),
                React.createElement("div", { className: badgeStyles.badgeReaderBox, "aria-hidden": "true", id: "flyoutButtonBadgeReaderBox_numeric" }, flyoutButtonBadgeDescription)));
        }
        else if ((enabledFlyoutButtonBadgeType === 'Dot' && numericBadgeCount > 0) ||
            (enabledFlyoutButtonBadgeType === 'Dot' && hasDotBadge) ||
            (enabledFlyoutButtonBadgeType === 'All' && hasDotBadge)) {
            var dotBadgeClassNames = mergeClasses(badgeStyles.dotBadgeCommon, badgeStyles.flyoutButtonBadge);
            badgeElement = (React.createElement(React.Fragment, null,
                React.createElement(CounterBadge, { size: "small", shape: "circular", color: "danger", appearance: "filled", count: undefined, className: dotBadgeClassNames, dot: true }),
                React.createElement("div", { className: badgeStyles.badgeReaderBox, "aria-hidden": "true", id: "flyoutButtonBadgeReaderBox_dot" }, flyoutButtonBadgeDescription)));
        }
        return badgeElement;
    }, [
        badgeStyles.badgeReaderBox,
        badgeStyles.badgeWide,
        badgeStyles.defaultBadge,
        badgeStyles.dotBadgeCommon,
        badgeStyles.flyoutButtonBadge,
        badgeStyles.flyoutButtonBadgeWide,
        hasDotBadge,
        numericBadgeCount,
        enabledFlyoutButtonBadgeType,
        flyoutButtonBadgeDescription,
    ]);
    return badgeElement;
};
export default FlyoutButtonBadge;
//# sourceMappingURL=FlyoutButtonBadge.js.map